export const PRICING_CARDS = [
    {
        icon: 'users',
        title: __('Referral program builder'),
        text: __(
            'Use our AI powered builder to create a referral program. Page editors / upload HTML'
        ),
    },
    {
        icon: 'puzzle',
        title: __('Widgets, pop ups, embeds.'),
        text: __(
            'Install pop ups and widgets on your website. These can work for logged out, and logged in users.'
        ),
    },
    {
        icon: 'cube',
        title: __('Out of the box tracking'),
        text: __('Send new referrals into your workflows. Automated conversion tracking.'),
    },
    {
        icon: 'data',
        title: __('Integrations and automations'),
        text: __(
            'Connect to HubSpot, Stripe, Intercom, Salesforce, Zoho, Pipedrive, Zapier and more.'
        ),
    },
    {
        icon: 'award',
        title: __('200+ types of rewards'),
        text: __(
            '200+ gift cards in multiple currencies. Cash payouts. Custom rewards for swag, tokens, discounts, coupons.'
        ),
    },
    {
        icon: 'alert',
        title: __('Fraud alerts'),
        text: __(
            'Track users that sign up from the same IP, or using suspect emails. Don’t issue rewards for fake referrals.'
        ),
    },
];

export const PRICING_FAQ = [
    {
        title: __('How many free trial days do you get with Referral Factory?'),
        text: __(
            'You’ll get 15 days to try Referral Factory for free. Thats enough time to fully test our referral program software from end to end.'
        ),
    },
    {
        title: __('Will my card be auto-charged at the end of my trial?'),
        text: __(
            'Yes, unless you cancel your account before the trial ends, your card will be charged. This is designed to make sure the customers who want to stay have no interruptions in their campaigns. If you want to avoid this auto-charge, you need to cancel your account BEFORE your trial expires. You can do this either by navigating to your billing page inside our referral software and hitting cancel, or my messaging us through the chat widget to request your account be cancelled.'
        ),
    },
    {
        title: __('Can I cancel at any time?'),
        text: __(
            'Yes, there are no forced long term commitments with Referral Factory! You can sign up, start a subscription, and cancel at anytime if you’re not happy with the referral program software we provide. Once you cancel your account, there will be NO future charges.'
        ),
    },
    {
        title: __('Why do you need a credit card to unlock a full-trial?'),
        text: __(
            'A credit card is required because your referral program might go live during your trial, and we want to make sure the users participating in your campaign experience no down time if your trial ends before you’ve had time to add your card. '
        ),
    },
    {
        title: __('Which is the best Referral Factory plan for large corporations? '),
        text: __(
            'Referral Factory offers an enterprise plan starting at $1000 (you get 20% off if you purchase annually). This plan includes our full suite of referral marketing tools plus SSO, host your own data on prem or in the cloud, upload your own html pages and emails, pay by invoice, and a dedicated account manager. Referral programs offer large organizations an interesting way to turn your customers into ambassadors for your brand.'
        ),
    },
    {
        title: __('Can you purchase more users on Referral Factory? '),
        text: __(
            'Yes, you can purchase batches of 100 000 users for $100. Our pricing is designed to scale as you grow, giving you the power to scale to millions of users as your community or organization grows.'
        ),
    },
    {
        title: __('If I purchase annually, can I get a refund after a few months?'),
        text: __(
            'We do not issue refunds on annual plans. We advise that you start with a monthly plan until you’re confident you’re ready to make a long term commitment. You can always upgrade to annual to get the 20% saving once you’re sure that Referral Factory is the referral program software for you.'
        ),
    },
    {
        title: __('What time zones does Referral Factory offer customer support?'),
        text: __(
            'We offer support 24/7 in english, Spanish and Portuguese. Our team of referral software experts can help you navigate the platform, and answer any questions you have. You will find a chat widget in the platform, buttons to load support tickets, as well as the option to book video call support calls if you’re on the basic plan or above. '
        ),
    },
    {
        title: __('Can I speak to a sales rep to advise me on the best plan for me?'),
        text: __('You sure can! Visit this :link on our website to schedule your own demo. '),
        link: 'web.pages.demo',
        linkWord: 'page',
    },
];
